import { useState } from 'react';
import { Alert, Box, Button, IconButton, InputAdornment, TextField, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { fetchClienteByNumCliente, useComercialContext } from './ComercialContext';
import { isSuccess } from '../common/domain/RemoteData.model';

const ComercialBanner = () => {
    const { actingAsCliente, setActingAsCliente, clearActingAsCliente } = useComercialContext();
    const [inputValue, setInputValue] = useState('');
    const [error, setError] = useState(null);

    const handleSearch = async () => {
        if (!inputValue.trim()) return;
        setError(null);
        const result = await fetchClienteByNumCliente(inputValue.trim());
        if (isSuccess(result)) {
            setActingAsCliente(result.value);
            setInputValue('');
        } else {
            setError('Cliente no encontrado');
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') handleSearch();
    };

    return (
        <Alert
            severity="warning"
            sx={{ borderRadius: 0, alignItems: 'center' }}
            icon={false}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
                <Typography variant="body2" fontWeight="bold">
                    Modo comercial
                </Typography>
                {actingAsCliente ? (
                    <>
                        <Typography variant="body2">
                            Actuando como: <strong>{actingAsCliente.nombreRazonSocial}</strong> ({actingAsCliente.numCliente})
                        </Typography>
                        <Button size="small" variant="outlined" color="warning" onClick={clearActingAsCliente}>
                            Cambiar cliente
                        </Button>
                    </>
                ) : (
                    <TextField
                        size="small"
                        placeholder="Número de cliente"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        onKeyDown={handleKeyDown}
                        error={!!error}
                        helperText={error}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton size="small" onClick={handleSearch}>
                                        <SearchIcon fontSize="small" />
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                        sx={{ background: 'white' }}
                    />
                )}
            </Box>
        </Alert>
    );
};

export default ComercialBanner;
